export default __webpack_public_path__ + "static/lifetime-logo-96eaa102d751bfadfb214739446ab95a.svg";